import * as React from "react";
import { Provider } from "react-redux";

// For custom scrollbar used on Monthly Mobile Event View:
import "jquery-mousewheel";
import "malihu-custom-scrollbar-plugin";

import "core-js/fn/object/assign"; // Polyfill for Object.assign for IE.

import configureStore from "./store/configureStore";

import CalendarContainer from "./components/Calendar/CalendarContainer";

import defState from "./reducers/initialState";

import { ICalendarSettingsState } from "./classes/state";

import { setCalendarSettingsFromPortlet } from "./actions/calendarSettingsActions";
import { requestAdditonalCalendarSettingsFromService } from "./actions/searchToolbarActions";

export interface ICalendarReduxProviderProps extends React.Props<CalendarReduxProvider> {
  action: string;
  calendarId: number;
  contextId: number;
  currentDate: Date;
  displayedEventId: number;
  firstDayOfWeek: string;
  headerAndBorderColor: string;
  pageId: number;
  pageName: string;
  parentId: number;
  portalId: number;
  portletInstanceId: number;
  selectedDateColor: string;
  todayColor: string;
  todaysDate: Date;
  viewMode: string;
}

class CalendarReduxProvider extends React.Component<ICalendarReduxProviderProps, any> {

  private store: any;

  constructor(props, context) {
    super(props, context);
    this.store = configureStore(defState);

    let eventScreenMode = "LIST";
    if (this.props.displayedEventId !== 0) {
      eventScreenMode = "VIEW";
    }

    const initialSettingsFromPortlet: ICalendarSettingsState = {
      ...props,
      eventScreenMode,
      localFromDate: new Date(),
      localToDate: new Date(),
    };

    this.store.dispatch(setCalendarSettingsFromPortlet(initialSettingsFromPortlet));
    this.store.dispatch(requestAdditonalCalendarSettingsFromService(this.props.portletInstanceId, this.props.calendarId));
  }

  public render() {
    return (
      <div>
        <Provider store={this.store}>
          <CalendarContainer />
        </Provider>
      </div>
    );
  }

}

export default CalendarReduxProvider;
